import React from "react";

import DashboardLayout from "src/components/layout/dashboard/Layout";
import Accordion from "src/components/ui/Accordion";
import ProfileCardTenant from "src/components/cards/ProfileCardTenant";
import ResetPasswordCard from "src/components/cards/ResetPasswordCard";
import TenantDetailsCard from "src/components/cards/TenantDetailsCard";
import PageHeader from "src/components/common/PageHeader";
import Button from "src/components/ui/Button";

import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { LogOut } from "lucide-react";
import * as authActions from "src/redux/slices/authTenantSlice";
import { useNavigate } from "react-router-dom";
import { logoutAndRedirect } from "src/utils/auth";

const SettingsPage: React.FC = () => {
  const navigate = useNavigate();

  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(authActions.logout());
    logoutAndRedirect({ navigate });
  };

  return (
    <DashboardLayout
      meta={{
        title: "Settings | Invyntra",
        description:
          "Manage and update your account settings, security preferences, and team permissions.",
        keywords: "settings, account, security, permissions, invyntra",
      }}
    >
      <div className="space-y-4">
        {/* Header */}
        <PageHeader
          title="Settings"
          breadcrumbData={[
            { label: "Home", path: "/app/dashboard" },
            { label: "Settings", path: "/app/settings" },
          ]}
        />

        {/* Settings Sections */}
        <div className="space-y-4">
          <Accordion title="Profile" defaultOpen={true}>
            <ProfileCardTenant />
          </Accordion>

          {user?.role !== "admin" && (
            <Accordion title="Company Details">
              <TenantDetailsCard />
            </Accordion>
          )}

          <Accordion title="Change Password">
            <ResetPasswordCard />
          </Accordion>

          {/* <Accordion title="Account Preferences">
            <AccountPreferencesCard />
          </Accordion> */}

          <div>
            <Button variant="primary" color="danger" onClick={handleLogout}>
              <LogOut size={16} />
              <span>Sign out</span>
            </Button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SettingsPage;
